import React, { useState, useRef, useEffect } from 'react';
import { Modal, App } from 'antd';
import { useTranslation } from 'react-i18next';
import CreateCodes, { CreateCodesRef } from '@/pages/Warehouse/components/CreateCodes';

interface BarcodeEditModalProps {
  open: boolean;
  initialBarcodes?: string[];
  originBarcodes?: string[];
  createNum?: number;
  onOk: (barcodes: string[]) => void;
  onCancel: () => void;
}

const BarcodeEditModal: React.FC<BarcodeEditModalProps> = ({ 
  open, 
  initialBarcodes = [], 
  originBarcodes,
  createNum,
  onOk, 
  onCancel 
}) => {
  const { t } = useTranslation();
  const { notification } = App.useApp();
  const createCodesRef = useRef<CreateCodesRef | null>(null);
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    if (open && initialBarcodes.length > 0) {
      setValue(initialBarcodes.join('\n'));
    }
  }, [open, initialBarcodes]);

  const handleOk = () => {
    const validation = createCodesRef.current?.getValidate();
    if (validation?.isValid) {
      // 如果有 originBarcodes，检查是否有不存在的条码
      if (originBarcodes && originBarcodes.length > 0) {
        const originSet = new Set(originBarcodes);
        const invalidBarcodes = validation.codes.filter(code => !originSet.has(code));
        
        if (invalidBarcodes.length > 0) {
          notification.error({ placement: 'top',
            message: t('warehouse.validationError'),
            description: t('warehouse.barcodesNotInOriginal', { barcodes: invalidBarcodes.join('、') })
          });
          return;
        }
      }
      
      onOk(validation.codes);
      setValue('');
    }
  };

  const handleCancel = () => {
    setValue('');
    onCancel();
  };

  return (
    <Modal
      title={t('warehouse.editBarcodes')}
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      width={600}
      destroyOnClose
    >
      <CreateCodes
        crRef={createCodesRef}
        value={value}
        onChange={setValue}
        originBarcodes={originBarcodes}
        createNum={createNum}
      />
    </Modal>
  );
};

export default BarcodeEditModal;